module.exports = __webpack_public_path__ + "img/bg-pins-desktop@2x.0afb67f.png";